import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleAPIRequest } from "../../api/api";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye } from "react-icons/fa";
import dayjs from "dayjs";
import DOMPurify from "dompurify";
import useMembershipStatus from "../../useMemberShipStatus";
import noImg from "../../assets/images/nia.jpg"; // Add a fallback image

const SearchedTenders = ({ searchTerm, filter, selectedCountry, isInternational }) => {
  useMembershipStatus();
  const { isAuthenticated, user, role, membershipStatus } = useSelector((state) => state.auth);
  const [tenders, setTenders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSearchedTenders = async () => {
      try {
        const formData = new FormData();
        formData.append("term", searchTerm);
        formData.append("type", filter);
        if (selectedCountry) {
          formData.append("country_id", selectedCountry);
        }
        formData.append("is_international", isInternational);

        const response = await handleAPIRequest("post", "tender/search", formData, null);
        setTenders(Array.isArray(response.tenders) ? response.tenders : []);
      } catch (error) {
        console.error("Error fetching searched tenders:", error);
        setError("Failed to fetch tenders.");
      } finally {
        setLoading(false);
      }
    };

    fetchSearchedTenders();
  }, [searchTerm, filter, selectedCountry, isInternational]);

  const handleApplyNow = (tender) => {
    if (!isAuthenticated) {
      toast.error("Please login first to apply for this tender.");
      return;
    }
    if (membershipStatus === "inactive" && role !== "super_admin" && role !== "admin") {
      toast.error("Please upgrade your membership to view this tender.");
      return;
    }
    navigate("/single-tender", { state: { tender } });
  };

  if (loading) return <p>Loading tenders...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 w-full max-w-7xl mx-auto">
      {tenders.length > 0 ? (
        tenders.map((tender) => (
          <div
            key={tender.id}
            className="bg-white flex flex-col p-3 rounded-lg shadow-md border hover:shadow-lg transition-all"
          >
            <img
              src={tender?.company_document?.document_url || noImg}
              alt={tender.tender_title}
              className="w-full h-28 object-cover rounded-md"
            />
            <div className="flex-grow flex flex-col justify-between mt-2">
              <h3 className="text-sm font-bold text-gray-800">
                {tender.tender_title}
              </h3>
              <div className="flex flex-wrap gap-1 my-1">
                <span className="text-xs text-white bg-green-500 px-2 py-1 rounded-md">
                  Start: {dayjs(tender.tender_start_date).format("DD MMM YYYY")}
                </span>
                <span className="text-xs text-white bg-red-500 px-2 py-1 rounded-md">
                  End: {dayjs(tender.tender_end_date).format("DD MMM YYYY")}
                </span>
                <span className="text-xs text-white bg-purple-500 px-2 py-1 rounded-md">
                  {tender.companies.company_name}
                </span>
                <span className="text-xs px-2 py-1 rounded-md bg-gray-500 text-white">
                  {tender.bid_method === "Online" ? "Online Bid" : "Manual Bid"}
                </span>
              </div>
              <button
                onClick={() => handleApplyNow(tender)}
                className="mt-1 text-blue-600 hover:text-blue-700 self-end"
              >
                <FaEye size={18} />
              </button>
            </div>
          </div>
        ))
      ) : (
        <p className="col-span-full text-center">No tenders found for the selected criteria.</p>
      )}
      <ToastContainer />
    </div>
  );
};

export default SearchedTenders;
